import React, { useState } from 'react';
import { ConfirmModal, openNotification } from 'tt-ui-lib/core';
import { LitterBinIcon, WarningIcon } from 'tt-ui-lib/icons';
import { deletePostComment } from '../../../api/posts/endpoints/posts';
import styles from './Comments.module.scss';

const CommentsActions = ({
  user,
  commentInstance,
  closeMenu,
  onDeleteComment,
  isReply = false,
}) => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [loadingAction, setLoadingAction] = useState(false);

  const removeComment = () => {
    setLoadingAction(true);

    deletePostComment(commentInstance.id, user.id)
      .then((response) => {
        if (response.status === 200) {
          openNotification({
            message: 'Your comment has been successfully deleted.',
            type: 'success',
          });
          setShowDeleteModal(false);
          closeMenu();
          onDeleteComment();
        }
      })
      .catch((e) => {
        openNotification({
          message: 'Error while removing comment. Try again later.',
          type: 'error',
        });
      })
      .finally(() => {
        setLoadingAction(false);
      });
  };

  const userCommentActions = (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      {/* <MenuItem */}
      {/*  onClick={() => { */}
      {/*    // TODO */}
      {/*  }} */}
      {/* > */}
      {/*  <EditIcon style={{ width: 18, height: 18, marginRight: 10 }} /> */}
      {/*  Edit */}
      {/* </MenuItem> */}
      <div
        className={styles.commentAction}
        onClick={() => {
          setShowDeleteModal(true);
        }}
      >
        <LitterBinIcon
          className="icon-red-fill"
          style={{ width: 18, height: 18, marginRight: 10 }}
        />
        Delete
      </div>
    </div>
  );

  const otherCommentActions = (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <div
        className={styles.commentAction}
        onClick={() => {
          // TODO
        }}
      >
        <WarningIcon className="icon-red-fill" style={{ width: 18, height: 18, marginRight: 10 }} />
        Report
      </div>
    </div>
  );

  return (
    <>
      {user.id === commentInstance.user.id ? userCommentActions : otherCommentActions}

      <ConfirmModal
        open={showDeleteModal}
        title={`Do you want to delete a ${isReply ? 'reply' : 'comment'}?`}
        subTitle={`Your ${isReply ? 'reply' : 'comment'} will be deleted permanently`}
        okText="Delete"
        loading={loadingAction}
        onConfirm={() => removeComment()}
        onClose={() => {
          setShowDeleteModal(false);
          closeMenu();
        }}
      />
    </>
  );
};

export default CommentsActions;
